import { SearchOrders } from "./ui";

export default SearchOrders;
